/* eslint-disable jsx-a11y/iframe-has-title */
import {
  Box,
  Button,
  Chip,
  Grid2 as Grid,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Delete from "../../Assets/Img/Delete-overview.png";
import Edit from "../../Assets/Img/Edit-overview.png";
import NoCamp from "../../Assets/Img/amico.svg";
import create from "../../Assets/Img/create dashboard.png";
import axiosMain from "../../http/axiosMain";
import statesData from "./statesData";
import utc from "dayjs/plugin/utc";

// import ProfileImg from "../Assets/Img/Imgs.png";

// import Search from "../../Assets/Img/search.png";
import dayjs from "dayjs";
import { BoxWithBorder } from "../../Common/Components/BoxWithBorder";
import { theme } from "../../Common/SetupProfile/constant";
// import { GoArrowUpRight } from "react-icons/go";
import { Button as BootstrapButton, Modal } from "react-bootstrap";
import { GlobalContext } from "../../../utils/GlobalContext";
import { showErrorToast, showSuccessToast } from "../../../utils/functions";
import ContractforCollaboration from "./ContractforCollaboration";

dayjs.extend(utc);

function CampaignDetails() {
  const { requestId, setRequestId } = useContext(GlobalContext);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { id } = useParams();
  const [selectedState, setSelectedState] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedAge, setSelectedAge] = useState([]);
  const [selectedGender, setSelectedGender] = useState([]);
  const [timeLine, setTimeLine] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const tabType = location.state?.tabType || "";
  const [priviewContract, setpriviewContract] = useState(false);
  const [contractLink, setContractLink] = useState();
  const openPriviewModal = (link) => {
    setpriviewContract(true);
    setContractLink(link);
  };
  const closePriviewModal = () => setpriviewContract(false);
  // button show specific pages
  const showEditDelete =
    tabType.toLowerCase() === "draft" || tabType.toLowerCase() === "scheduled";

  const showButtons = tabType.toLowerCase() === "ongoing"; // Display buttons only if tabType is 'ongoing'
  const MAX_LANGUAGES = 4;
  // Ensure selectedLanguages is an array and map it to their full names
  const selectedLangNames = Array.isArray(selectedLanguages)
    ? selectedLanguages.map((shortName) => {
        const lang = languages.find(
          (language) => language.short_name === shortName
        );
        return lang ? lang.name : shortName;
      })
    : []; // Default to an empty array if selectedLanguages is not an array

  // Check if the number of selected languages exceeds MAX_LANGUAGES
  const showMoreLanguages = selectedLangNames.length > MAX_LANGUAGES;

  const [CampaignFormCreate, setCampaignFormCreate] = useState(null);
  const [showContractModal, setShowContractModal] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  // for states
  useEffect(() => {
    if (CampaignFormCreate?.state) {
      setSelectedState(
        Array.isArray(CampaignFormCreate.state)
          ? CampaignFormCreate.state
          : [CampaignFormCreate.state]
      );
    }
  }, [CampaignFormCreate]);

  // for city
  useEffect(() => {
    if (CampaignFormCreate?.city) {
      setSelectedCity(
        Array.isArray(CampaignFormCreate.city)
          ? CampaignFormCreate.city
          : [CampaignFormCreate.city] // convert single value to array
      );
    }
  }, [CampaignFormCreate]);

  // for languages

  useEffect(() => {
    if (CampaignFormCreate?.language) {
      setSelectedLanguages(
        Array.isArray(CampaignFormCreate.language)
          ? CampaignFormCreate.language
          : [CampaignFormCreate.language]
      );
    }
  }, [CampaignFormCreate]);

  // for age
  useEffect(() => {
    if (CampaignFormCreate && CampaignFormCreate.age_group) {
      const ageList = Array.isArray(CampaignFormCreate.age_group)
        ? CampaignFormCreate.age_group
        : [CampaignFormCreate.age_group];
      setSelectedAge(ageList);
    } else {
      setSelectedAge([]); // fallback to empty array
    }
  }, [CampaignFormCreate]);

  // for gender
  useEffect(() => {
    if (CampaignFormCreate?.gender) {
      setSelectedGender(
        Array.isArray(CampaignFormCreate.gender)
          ? CampaignFormCreate.gender
          : [CampaignFormCreate.gender]
      );
    }
  }, [CampaignFormCreate?.gender]); // ✅ update dependency to gender specifically

  // for gender
  useEffect(() => {
    if (CampaignFormCreate?.setTimeLine) {
      setTimeLine(
        Array.isArray(CampaignFormCreate.setTimeLine)
          ? CampaignFormCreate.setTimeLine
          : [CampaignFormCreate.setTimeLine]
      );
    }
  }, [CampaignFormCreate?.setTimeLine]); // ✅ update dependency to gender specifically

  // Campaign Deliverables
  const formatDeliverableName = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // useEffect to load the active tab from localStorage when component mounts
  useEffect(() => {
    // Check if there is a saved tab in localStorage
    const savedTab = localStorage.getItem("activeTab");

    // If a saved tab exists, use it, otherwise default to "campaignDetails"
    if (savedTab) {
      setActiveTab(savedTab);
    }
  }, []); // Only run once when the component mounts

  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("activeCampaignTab") || "campaignDetails";
  });

  useEffect(() => {
    if (localStorage.getItem("activeCampaignTab")) {
      setActiveTab(localStorage.getItem("activeCampaignTab"));
    } else {
      setActiveTab("campaignDetails");
    }
  }, []);

  const [currentCampaign, setCurrentCampaign] = useState({});
  const today = new Date().toLocaleDateString("en-CA");

  const isDraftOrScheduled =
    CampaignFormCreate?.issavedasdraft === 1 ||
    new Date(CampaignFormCreate?.start_date).toLocaleDateString("en-CA") >
      today;
  const navigate = useNavigate();
  const [influencers, setInfluencers] = useState([]);
  // Fetch the campaign data
  const fetchCampaign = async () => {
    try {
      const response = await axiosMain.get("/api/v1/campaigns", {
        params: {
          campaign_id: id,
        },
      });

      const campaign = response.data.campaigns[0];

      setCampaignFormCreate(campaign);

      if (campaign.timeline) {
        setTimeLine(campaign.timeline);
      } else {
        setTimeLine([]); // Optional: Clear if not found
      }
    } catch (error) {
      console.error("Error fetching campaign:", error);
    }
  };

  const handleDeleteCampaign = async () => {
    try {
      await axiosMain.delete(`/api/v1/campaigns/${id}`);
      showSuccessToast("Campaign deleted successfully!");
      setShowModal(false);
      navigate("/campaign");
    } catch (error) {
      console.error("Delete error:", error);
      showErrorToast(
        `Failed to delete: ${
          error?.response?.data?.message || "Something went wrong"
        }`
      );
    }
  };

  const revoke = async (requestId) => {
    try {
      const response = await axiosMain.delete(
        "/api/campaign/delete-campaign-status",
        {
          params: { request_id: requestId }, // query param here
        }
      );

      if (response.status === 200 && response.data.success) {
        console.log(response.data.message); // Campaign Status Updated Successfully
        myCampaign("Sent"); // refresh campaign data
      } else {
        console.error("Unexpected response:", response.data);
      }
    } catch (error) {
      console.error("Failed to revoke request:", error);
    }
  };

  // Function to mark the campaign as completed

  const markCampaignAsCompleted = async (id) => {
    try {
      const response = await axiosMain.post("/api/v1/create-campaign", {
        flag_campaign_finished: true,
        flag_update: true,
        campaign_id: id,
      });
      if (response?.data?.updatedCampaign) {
        // console.log("✅ Campaign marked as completed.");
        showSuccessToast(response?.data?.message);
        // Delay to allow user to see the toast
        setTimeout(() => {
          navigate("/campaign");
        }, 1200);
      } else {
        showErrorToast("Failed to mark campaign as completed.");
      }
    } catch (error) {
      console.error("❌ Error marking campaign as completed:", error);
      showErrorToast("Something went wrong. Please try again.");
    }
  };

  const createNavigate = () => {
    navigate("/campaign-create");
  };
  // this use effect use for hide last 5 li
  useEffect(() => {
    fetchCampaign().then((data) => {
      setCurrentCampaign(data);
    });
  }, []);

  // navigate in collab-req-page
  const ViewDetails = (id) => {
    navigate(`/collab-request/${id}`);
  };

  const UnsendContract = async (id) => {
    try {
      const response = await axiosMain.put("/api/v1/unsend-contract", {
        request_id: id,
      });

      if (response.status === 200) {
        myCampaign("", "Pending"); // refresh campaign data
      } else {
        console.error("Unexpected response:", response.data);
      }
    } catch (error) {
      console.error("Unsend failed:", error.response?.data || error.message);
      throw error;
    }
  };

  useEffect(() => {
    fetchCampaign();
  }, []);

  // Tab change handler
  const handleTabChange = (tab, reqStatus, contractStatus) => {
    setActiveTab(tab);
    localStorage.setItem("activeCampaignTab", tab);
    localStorage.setItem("activeTab", tab); // Save the active tab to localStorage
    myCampaign(reqStatus, contractStatus);
  };

  const SendContract = (reqId) => {
    try {
      setSelectedRequestId(reqId.request_id); // Save the ID
      console.log("kanjjjjjjjjjjjjjjjjjjjjj", reqId.request_id);
      setRequestId(reqId.request_id);
      setShowContractModal(true); // Open the modal
    } catch (error) {
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const myCampaign = (reqStatus, contractStatus) => {
    const params = {
      campaign_id: id,
    };

    if (reqStatus !== "") {
      params.request_status = reqStatus;
    }
    // debugger;
    if (contractStatus !== "") {
      params.contract_status = contractStatus;
    }

    axiosMain
      .get("/api/v1/my-campaign-requests", { params })
      .then((response) => {
        // Set the campaign requests to state
        setInfluencers(response.data);
      })
      .catch((error) => {
        // Handle error
        // setError(error);
      });
  };

  useEffect(() => {
    myCampaign("Received");
  }, [id]);

  const fetchNotifications = async (influencer_id, brand_id) => {
    try {
      const response = await axiosMain.post(
        "/api/notifications/notifications",
        {
          sender_user_id: brand_id, // Pass sender ID
          receiver_user_id: influencer_id, // Pass receiver ID
          message: `${
            "Your request has been accepted by" +
            " " +
            `${CampaignFormCreate?.campaign_title} ` +
            " " +
            "for" +
            " " +
            localStorage.getItem("brandName")
          }`,
        }
      );
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const acceptRej = (influencer, action) => {
    console.log(influencer.request_id);

    const payload = {
      request_id: influencer.request_id,
      action: action,
      campaign_id: influencer.campaign_id,
    };

    axiosMain
      .post("/api/v1/accept-request", payload)
      .then((response) => {
        console.log("Response from accept-request:", response.data);

        // Call the second API to send a message
        const chatPayload = {
          conversationId: "new", // Use 'new' or your dynamic ID as required
          senderId: influencer.influencer_id, // Assuming influencer_id is the sender
          receiverId: influencer.brand_id,
          message: influencer.message
            ? influencer.message
            : "Your request has been accepted!", // Customize the message as needed
        };

        axiosMain
          .post("/api/chat/message", chatPayload)
          .then((chatResponse) => {
            console.log("Response from chat message:", chatResponse.data);
            // Optionally do something after sending the message
          })
          .catch((chatError) => {
            console.error("Error sending chat message:", chatError);
          });

        // Call additional functions
        myCampaign("Received", "");
        fetchNotifications(influencer.influencer_id, influencer.brand_id);
      })
      .catch((error) => {
        console.error("Error in accept-request:", error);
      });

    // // In case you want myCampaign called again outside the main axios flow:
    // myCampaign();
  };
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearch = async (e) => {
    setSearchTerm(e.target.value);
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (!searchTerm) {
  //       // Perform the API call on component mount
  //       axiosMain
  //         .get("/api/v1/my-campaign-requests", {
  //           params: {
  //             campaign_id: id,
  //           },
  //         })
  //         .then((response) => {
  //           // Set the campaign requests to state
  //           setInfluencers(response.data.requests);
  //         })
  //         .catch((error) => {
  //           // Set error if the request fails
  //           // setError(error);
  //         });
  //       return;
  //     }

  //     try {
  //       const response = await axiosMain.get(
  //         `/api/v1/search-influencer?search=${searchTerm}`
  //       );
  //       setInfluencers(response.data.requests); // Assuming the response contains the data directly
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } finally {
  //     }
  //   };

  //   // Debounce to avoid making too many requests on every keystroke
  //   const timer = setTimeout(() => fetchData(), 500);

  //   // Cleanup on searchTerm change
  //   return () => clearTimeout(timer);
  // }, [searchTerm]);

  const backNavigate = () => {
    navigate(-1);
    localStorage.removeItem("activeCampaignTab");
    localStorage.removeItem("activeTab");
  };

  const editCampaigns = async () => {
    try {
      const response = await axiosMain.get("/api/v1/campaigns", {
        params: { campaign_id: id },
      });

      const campaign = response.data?.campaigns?.[0]; // <-- Get first campaign

      console.log(campaign, "campaign");

      if (campaign) {
        setCampaignFormCreate(campaign);
        localStorage.setItem("editCampaign", JSON.stringify(campaign));
        navigate(`/campaign-create/${id}`);
      }

      if (campaign?.timeline) {
        setTimeLine(campaign.timeline);
      } else {
        setTimeLine([]); // Clear if timeline not found
      }
    } catch (error) {
      console.error("Error fetching campaign:", error);
    }
  };

  return (
    <>
      <div className="CampaignDetails">
        <div className="SearchFilterSection d-flex justify-content-between align-items-center mb-4">
          {/* <div className="SearchInput">
          <img src={Search} className="img-fluid" alt="Search Icon" />
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => handleSearch(e)}
            autoFocus
          />
        </div> */}
          <button
            // onClick={() => navigate(-1)}
            onClick={backNavigate}
            style={{ all: "unset", cursor: "pointer", fontSize: "20px" }}
          >
            &lt; Back
          </button>

          {/* <button className="RedBtn" onClick={() => createNavigate()}>
            Create new Campaign&nbsp;&nbsp;
            <img src={create} className="img-fluid" alt="Heart Icon" />
          </button> */}
          {/* <button>
          Filters <img src={Filter} className="img-fluid" alt="Filter Icon" />
        </button> */}
        </div>
        {/* Bootstrap Nav Pills */}
        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${
                activeTab === "campaignDetails" ? "active" : ""
              }`}
              id="pills-campaign-details-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-campaign-details"
              type="button"
              role="tab"
              aria-controls="pills-campaign-details"
              aria-selected={activeTab === "campaignDetails" ? "true" : "false"}
              onClick={() => handleTabChange("campaignDetails")}
            >
              Campaign Details
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${
                activeTab === "CollaborationSend" ? "active" : ""
              }`}
              id="pills-check-requests-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-check-requests"
              type="button"
              role="tab"
              aria-controls="pills-check-requests"
              aria-selected={
                activeTab === "CollaborationSend" ? "true" : "false"
              }
              onClick={() => handleTabChange("CollaborationSend", "Sent", "")}
              style={{ display: "flex" }}
            >
              Collaborations Sent
              {influencers?.requestStatusCountData?.at(0)?.sent !== 0 && (
                <span
                  style={{
                    width: "20px",
                    height: "20px",
                    background: "#FF4949",
                    borderRadius: "50%",
                    color: "#fff",
                    fontSize: "9px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "500",
                    border: "2px solid white",
                    marginLeft: "2px",
                    fontFamily: "Poppins,sans-serif",
                  }}
                >
                  {influencers?.requestStatusCountData?.at(0)?.sent}
                </span>
              )}
            </button>
          </li>
          {!isDraftOrScheduled && (
            <>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "campaignCollaborations" ? "active" : ""
                  }`}
                  id="pills-campaign-collaborations-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-campaign-collaborations"
                  type="button"
                  role="tab"
                  aria-controls="pills-campaign-collaborations"
                  aria-selected={
                    activeTab === "campaignCollaborations" ? "true" : "false"
                  }
                  onClick={() =>
                    handleTabChange("campaignCollaborations", "Received", "")
                  }
                  style={{ display: "flex" }}
                >
                  Collaborations Received
                  {influencers?.requestStatusCountData?.at(0)?.received !==
                    0 && (
                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        background: "#FF4949",
                        borderRadius: "50%",
                        color: "#fff",
                        fontSize: "9px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "500",
                        border: "2px solid white",
                        marginLeft: "2px",
                        fontFamily: "Poppins,sans-serif",
                      }}
                    >
                      {influencers?.requestStatusCountData?.at(0)?.received}
                    </span>
                  )}
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "acceptedCollaborations" ? "active" : ""
                  }`}
                  id="pills-accepted-collaborations-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-accepted-collaborations"
                  type="button"
                  role="tab"
                  aria-controls="pills-accepted-collaborations"
                  aria-selected={
                    activeTab === "acceptedCollaborations" ? "true" : "false"
                  }
                  onClick={() =>
                    handleTabChange("acceptedCollaborations", "Accepted", "")
                  }
                  style={{ display: "flex" }}
                >
                  Collaborations Accepted
                  {influencers?.requestStatusCountData?.at(0)?.accepted !==
                    0 && (
                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        background: "#FF4949",
                        borderRadius: "50%",
                        color: "#fff",
                        fontSize: "9px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "500",
                        border: "2px solid white",
                        marginLeft: "2px",
                        fontFamily: "Poppins,sans-serif",
                      }}
                    >
                      {influencers?.requestStatusCountData?.at(0)?.accepted}
                    </span>
                  )}
                </button>
              </li>
              {/* <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${
              activeTab === "All Requests" ? "active" : ""
            }`}
            id="pills-accepted-collaborations-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-accepted-collaborations"
            type="button"
            role="tab"
            aria-controls="pills-accepted-collaborations"
            aria-selected={activeTab === "All Requests" ? "true" : "false"}
            onClick={() => handleTabChange("AllRequests")}
          >
            All Requests
          </button>
        </li> */}
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "PendingContracts" ? "active" : ""
                  }`}
                  id="pills-accepted-collaborations-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-accepted-collaborations"
                  type="button"
                  role="tab"
                  aria-controls="pills-accepted-collaborations"
                  aria-selected={
                    activeTab === "PendingContracts" ? "true" : "false"
                  }
                  onClick={() =>
                    handleTabChange("PendingContracts", "", "Pending")
                  }
                  style={{ display: "flex" }}
                >
                  Contracts Sent
                  {influencers?.requestStatusCountData?.at(0)
                    ?.contract_pending !== 0 && (
                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        background: "#FF4949",
                        borderRadius: "50%",
                        color: "#fff",
                        fontSize: "9px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "500",
                        border: "2px solid white",
                        marginLeft: "2px",
                        fontFamily: "Poppins,sans-serif",
                      }}
                    >
                      {
                        influencers?.requestStatusCountData?.at(0)
                          ?.contract_pending
                      }
                    </span>
                  )}
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "AcceptedContracts" ? "active" : ""
                  }`}
                  id="pills-accepted-collaborations-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-accepted-collaborations"
                  type="button"
                  role="tab"
                  aria-controls="pills-accepted-collaborations"
                  aria-selected={
                    activeTab === "AcceptedContracts" ? "true" : "false"
                  }
                  onClick={() =>
                    handleTabChange("AcceptedContracts", "", "Accepted")
                  }
                  style={{ display: "flex" }}
                >
                  Contract Accepted
                  {influencers?.requestStatusCountData?.at(0)
                    ?.contract_accepted !== 0 && (
                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        background: "#FF4949",
                        borderRadius: "50%",
                        color: "#fff",
                        fontSize: "9px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "500",
                        border: "2px solid white",
                        marginLeft: "2px",
                        fontFamily: "Poppins,sans-serif",
                      }}
                    >
                      {
                        influencers?.requestStatusCountData?.at(0)
                          ?.contract_accepted
                      }
                    </span>
                  )}
                </button>
              </li>
            </>
          )}
        </ul>

        <div className="tab-content" id="pills-tabContent">
          {/* Campaign Details Tab */}
          {activeTab === "campaignDetails" && (
            <ThemeProvider theme={theme}>
              <Box
                sx={{
                  background: "#fff",
                  padding: "40px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                }}
              >
                <BoxWithBorder>
                  <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
                    <Box position={"relative"}>
                      <img
                        src={CampaignFormCreate?.campaign_poster}
                        alt="Campaign Banner"
                        style={{
                          maxHeight: "250px",
                          objectFit: "cover",
                          width: "100%",
                          borderRadius: "12px",
                          boxShadow:
                            "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
                        }}
                      />

                      {/* Edit & Delete Icons using Bootstrap */}
                      {showEditDelete && (
                        <div className="position-absolute top-0 end-0 p-2 d-flex gap-2">
                          <img
                            src={Edit}
                            alt="Edit"
                            title="Edit"
                            className="rounded-circle bg-white shadow-sm"
                            style={{
                              width: "38px",
                              height: "38px",
                              padding: "6px",
                              cursor: "pointer",
                            }}
                            onClick={() => editCampaigns()}
                          />
                          <img
                            src={Delete}
                            alt="Delete"
                            title="Delete"
                            className="rounded-circle bg-white shadow-sm"
                            style={{
                              width: "38px",
                              height: "38px",
                              padding: "6px",
                              cursor: "pointer",
                            }}
                            onClick={() => setShowModal(true)}
                          />
                        </div>
                      )}
                    </Box>
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                      marginY={"1rem"}
                    >
                      <Box>
                        <Typography fontSize={"24px"} fontWeight={600}>
                          {CampaignFormCreate?.campaign_title}{" "}
                          <span
                            style={{
                              fontWeight: 400,
                              color: "#9D9D9D",
                              fontSize: "16px",
                            }}
                          >
                            (
                            {dayjs(CampaignFormCreate?.start_date).format(
                              "DD/MM/YYYY"
                            )}{" "}
                            -{" "}
                            {dayjs(CampaignFormCreate?.end_date).format(
                              "DD/MM/YYYY"
                            )}
                            )
                          </span>
                        </Typography>
                      </Box>
                      {/* <Button style={{ cursor: "pointer" }}>
                        View Brand's Profile
                      </Button> */}
                    </Box>
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Box>
                        <Typography color="#656565">Product</Typography>
                        <Typography color="#121212">
                          {CampaignFormCreate?.product_name || "N/A"}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography color="#656565">Launch Date</Typography>
                        <Typography color="#121212">
                          {CampaignFormCreate?.launch_date
                            ? dayjs
                                .utc(CampaignFormCreate.launch_date)
                                .format("DD/MM/YYYY")
                            : "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </BoxWithBorder>
                <BoxWithBorder title={"Goals"}>
                  <Box>
                    <Typography color="#656565">Primary Objective</Typography>
                    <Typography color="#121212">
                      {CampaignFormCreate?.campaign_primary_objective || "N/A"}
                    </Typography>
                  </Box>
                  <Box marginTop={"8px"}>
                    <Typography color="#656565">Secondary Objective</Typography>
                    <Typography color="#121212">
                      {CampaignFormCreate?.campaign_secondary_objective ||
                        "N/A"}
                    </Typography>
                  </Box>
                </BoxWithBorder>
                <BoxWithBorder title={"Campaign Description"}>
                  <Typography>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: CampaignFormCreate?.description || "N/A",
                      }}
                    />
                  </Typography>
                </BoxWithBorder>

                <BoxWithBorder title={"Payment and Compensation"}>
                  <Box>
                    <Typography
                      color="#363636"
                      fontWeight={600}
                      fontSize={"18px"}
                    >
                      Payment Mode
                    </Typography>
                    <Typography color="#121212" fontSize={"14px"}>
                      {CampaignFormCreate?.compensation_type || "N/A"}
                    </Typography>
                  </Box>
                  <Box marginTop={"8px"}>
                    <Typography
                      color="#363636"
                      fontWeight={600}
                      fontSize={"18px"}
                    >
                      Budget
                    </Typography>
                    <Typography color="#121212" fontSize={"14px"}>
                      {CampaignFormCreate?.budget &&
                      !isNaN(CampaignFormCreate.budget)
                        ? new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                          }).format(CampaignFormCreate.budget)
                        : "N/A"}
                    </Typography>
                  </Box>
                </BoxWithBorder>
                <BoxWithBorder title={"Target Audience"}>
                  <Grid container spacing={2}>
                    <Grid size={6}>
                      <Box>
                        <Typography
                          color="#363636"
                          fontWeight={600}
                          fontSize={"18px"}
                        >
                          State
                        </Typography>

                        <Box display={"flex"} gap={1} marginTop={"4px"}>
                          {(() => {
                            const states = CampaignFormCreate?.state
                              ?.map(
                                (st) =>
                                  statesData.find((s) => s.iso2 === st)?.state
                              )
                              .filter(Boolean);
                            return (
                              <>
                                {states?.slice(0, 3)?.map((i) => {
                                  return <Chip label={i} />;
                                }) || "N/A"}
                                {states?.length > 3 && (
                                  <Tooltip
                                    title={
                                      <Box
                                        display="flex"
                                        flexDirection="column"
                                      >
                                        {states.slice(3).map((i, idx) => (
                                          <span key={idx}>{i}</span>
                                        ))}
                                      </Box>
                                    }
                                    placement="bottom"
                                    sx={{
                                      "& .MuiTooltip-tooltip": {
                                        fontFamily:
                                          "Poppins, sans-serif !important",
                                        fontSize: "14px",
                                        letterSpacing: "0.5px",
                                      },
                                    }}
                                  >
                                    <Chip
                                      sx={{
                                        backgroundColor: "#ccc",
                                        color: "#333",
                                        fontFamily: "Poppins, sans-serif",
                                        cursor: "pointer",
                                      }}
                                      label={`+ ${states.length - 3}`}
                                    />
                                  </Tooltip>
                                )}
                              </>
                            );
                          })()}
                        </Box>
                      </Box>
                    </Grid>
                    <Grid size={6}>
                      <Box>
                        <Typography
                          color="#363636"
                          fontWeight={600}
                          fontSize={"18px"}
                        >
                          City
                        </Typography>

                        <Box display={"flex"} gap={1} marginTop={"4px"}>
                          {(() => {
                            const cities = CampaignFormCreate?.city || [];
                            return (
                              <>
                                {cities?.length > 0
                                  ? cities
                                      .slice(0, 3)
                                      .map((i, index) => (
                                        <Chip key={index} label={i} />
                                      ))
                                  : "N/A"}

                                {cities?.length > 3 && (
                                  <Tooltip
                                    title={
                                      <Box
                                        display="flex"
                                        flexDirection="column"
                                      >
                                        {cities.slice(3).map((i, idx) => (
                                          <span key={idx}>{i}</span>
                                        ))}
                                      </Box>
                                    }
                                    placement="bottom"
                                    sx={{
                                      "& .MuiTooltip-tooltip": {
                                        fontFamily:
                                          "Poppins, sans-serif !important",
                                        fontSize: "14px",
                                        letterSpacing: "0.5px",
                                      },
                                    }}
                                  >
                                    <Chip
                                      sx={{
                                        backgroundColor: "#ccc",
                                        color: "#333",
                                        fontFamily: "Poppins, sans-serif",
                                        cursor: "pointer",
                                      }}
                                      label={`+ ${cities.length - 3}`}
                                    />
                                  </Tooltip>
                                )}
                              </>
                            );
                          })()}
                        </Box>
                      </Box>
                    </Grid>
                    <Grid size={6}>
                      <Box>
                        <Typography
                          color="#363636"
                          fontWeight={600}
                          fontSize={"18px"}
                        >
                          Gender
                        </Typography>

                        <Box display={"flex"} gap={1} marginTop={"4px"}>
                          {(() => {
                            const genders = CampaignFormCreate?.gender || [];
                            return (
                              <>
                                {genders?.length > 0
                                  ? genders
                                      .slice(0, 3)
                                      .map((i, index) => (
                                        <Chip
                                          key={index}
                                          label={i}
                                          sx={{ textTransform: "capitalize" }}
                                        />
                                      ))
                                  : "N/A"}

                                {genders?.length > 3 && (
                                  <Tooltip
                                    title={
                                      <Box
                                        display="flex"
                                        flexDirection="column"
                                      >
                                        {genders.slice(3).map((i, idx) => (
                                          <span key={idx}>{i}</span>
                                        ))}
                                      </Box>
                                    }
                                    placement="bottom"
                                    sx={{
                                      "& .MuiTooltip-tooltip": {
                                        fontFamily:
                                          "Poppins, sans-serif !important",
                                        fontSize: "14px",
                                        letterSpacing: "0.5px",
                                      },
                                    }}
                                  >
                                    <Chip
                                      sx={{
                                        backgroundColor: "#ccc",
                                        color: "#333",
                                        fontFamily: "Poppins, sans-serif",
                                        cursor: "pointer",
                                      }}
                                      label={`+ ${genders.length - 3}`}
                                    />
                                  </Tooltip>
                                )}
                              </>
                            );
                          })()}
                        </Box>
                      </Box>
                    </Grid>
                    <Grid size={6}>
                      <Box>
                        <Typography
                          color="#363636"
                          fontWeight={600}
                          fontSize={"18px"}
                        >
                          Language
                        </Typography>

                        <Box display={"flex"} gap={1} marginTop={"4px"}>
                          {(() => {
                            const language = CampaignFormCreate?.language || [];
                            return (
                              <>
                                {language?.length > 0
                                  ? language
                                      .slice(0, 3)
                                      .map((i, index) => (
                                        <Chip
                                          key={index}
                                          label={i.name}
                                          sx={{ textTransform: "capitalize" }}
                                        />
                                      ))
                                  : "N/A"}

                                {language?.length > 3 && (
                                  <Tooltip
                                    title={
                                      <Box
                                        display="flex"
                                        flexDirection="column"
                                      >
                                        {language.slice(3).map((i, idx) => (
                                          <span key={idx}>{i.name}</span>
                                        ))}
                                      </Box>
                                    }
                                    placement="bottom"
                                    sx={{
                                      "& .MuiTooltip-tooltip": {
                                        fontFamily:
                                          "Poppins, sans-serif !important",
                                        fontSize: "14px",
                                        letterSpacing: "0.5px",
                                      },
                                    }}
                                  >
                                    <Chip
                                      sx={{
                                        backgroundColor: "#ccc",
                                        color: "#333",
                                        fontFamily: "Poppins, sans-serif",
                                        cursor: "pointer",
                                      }}
                                      label={`+ ${language.length - 3}`}
                                    />
                                  </Tooltip>
                                )}
                              </>
                            );
                          })()}
                        </Box>
                      </Box>
                    </Grid>
                    <Grid size={6}>
                      <Box>
                        <Typography
                          color="#363636"
                          fontWeight={600}
                          fontSize={"18px"}
                        >
                          Age Group
                        </Typography>

                        <Box display={"flex"} gap={1} marginTop={"4px"}>
                          {(() => {
                            const ageGroup =
                              CampaignFormCreate?.age_group || [];
                            return (
                              <>
                                {ageGroup?.length > 0
                                  ? ageGroup
                                      .slice(0, 3)
                                      .map((i, index) => (
                                        <Chip
                                          key={index}
                                          label={i}
                                          sx={{ textTransform: "capitalize" }}
                                        />
                                      ))
                                  : "N/A"}

                                {ageGroup?.length > 3 && (
                                  <Tooltip
                                    title={
                                      <Box
                                        display="flex"
                                        flexDirection="column"
                                      >
                                        {ageGroup.slice(3).map((i, idx) => (
                                          <span key={idx}>{i}</span>
                                        ))}
                                      </Box>
                                    }
                                    placement="bottom"
                                    sx={{
                                      "& .MuiTooltip-tooltip": {
                                        fontFamily:
                                          "Poppins, sans-serif !important",
                                        fontSize: "14px",
                                        letterSpacing: "0.5px",
                                      },
                                    }}
                                  >
                                    <Chip
                                      sx={{
                                        backgroundColor: "#ccc",
                                        color: "#333",
                                        fontFamily: "Poppins, sans-serif",
                                        cursor: "pointer",
                                      }}
                                      label={`+ ${ageGroup.length - 3}`}
                                    />
                                  </Tooltip>
                                )}
                              </>
                            );
                          })()}
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </BoxWithBorder>
                <BoxWithBorder title={"Campaign Deliverables"}>
                  <div className="secret-santa p-2">
                    {timeLine.length > 0 && (
                      <div className="container mt-4">
                        {/* <h5 className="fw-semibold mb-3">Campaign Deliverables</h5> */}
                        <div className="table-responsive">
                          <table className="table campign-detail-deliverable table-bordered text-center align-middle deliverable-table">
                            <thead className="table-light">
                              <tr>
                                <th
                                  rowSpan={2}
                                  style={{ verticalAlign: "middle" }}
                                >
                                  Tools
                                </th>
                                <th
                                  rowSpan={2}
                                  style={{ verticalAlign: "middle" }}
                                >
                                  Deliverables
                                </th>
                                {timeLine.map((week, i) => (
                                  <th key={i}>Week{i + 1}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {Object.entries(timeLine[0]).map(
                                ([platform, deliverables], platformIndex) => (
                                  <>
                                    {Object.keys(deliverables).map(
                                      (deliverable, i) => (
                                        <tr key={`${platform}-${deliverable}`}>
                                          {i === 0 && (
                                            <td
                                              rowSpan={
                                                Object.keys(deliverables).length
                                              }
                                              className="fw-semibold"
                                            >
                                              {platform}
                                            </td>
                                          )}
                                          <td>
                                            {formatDeliverableName(deliverable)}
                                          </td>
                                          {timeLine.map((week, wIdx) => (
                                            <td key={wIdx}>
                                              {week[platform]?.[deliverable] > 0
                                                ? week[platform][deliverable]
                                                : 0}
                                            </td>
                                          ))}
                                        </tr>
                                      )
                                    )}
                                  </>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* <CampaignDeliverables timeline={timeLine} /> */}
                </BoxWithBorder>
                {/* Render Finish Campaign and Collaborate buttons only if tabType is 'ongoing' */}
                {(tabType.toLowerCase() === "ongoing" ||
                  tabType.toLowerCase() === "scheduled") && (
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"end"}
                    gap={2}
                  >
                    {tabType.toLowerCase() === "ongoing" && (
                      <Button
                        onClick={() => markCampaignAsCompleted(id)} // Mark as completed
                        variant="outlined"
                        sx={{
                          color: "#FF0000 !important",
                          borderColor: "#FF0000 !important",
                        }}
                      >
                        Finish Campaign
                      </Button>
                    )}
                    <Button variant="contained" onClick={() => ViewDetails(id)}>
                      Collaborate
                    </Button>
                  </Box>
                )}
              </Box>
            </ThemeProvider>
          )}
          {/* Campaign Collaborations Tab */}
          {activeTab === "campaignCollaborations" && (
            <div
              className="tab-pane fade show active"
              id="pills-campaign-collaborations"
              role="tabpanel"
              aria-labelledby="pills-campaign-collaborations-tab"
            >
              <div className="InfluancerCardView">
                {influencers?.requests?.length > 0 ? (
                  <>
                    <div className="influencer-card Menu">
                      <div
                        className="InfluencerProfile"
                        style={{ marginLeft: "-15px" }}
                      >
                        Creators
                      </div>
                      <div
                        className="InfluencerGenre"
                        style={{ marginLeft: "-68px", paddingLeft: "79px" }}
                      >
                        Genre
                      </div>

                      <div
                        className="InfluencerFollowes"
                        style={{ marginLeft: "-15px", paddingLeft: "70px" }}
                      >
                        Followers{" "}
                      </div>
                      <div
                        className="engagement"
                        style={{ marginLeft: "-26px", paddingLeft: "5px" }}
                      >
                        ER %
                      </div>
                      <div
                        className="InfluencerEngagement"
                        style={{ marginRight: "66px" }}
                      >
                        Actions
                      </div>
                    </div>
                    <div className="influencer-list">
                      {influencers?.requests?.map((influencer) => (
                        <div
                          key={influencer.influencer_id}
                          className="influencer-card"
                          onClick={() =>
                            navigate(`/influencer/${influencer?.influencer_id}`)
                          }
                        >
                          <div
                            className="InfluencerProfile"
                            style={{ marginLeft: "-22px" }}
                          >
                            <img
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "50px",
                              }}
                              src={
                                influencer?.influencer?.profile ||
                                "path/to/placeholder-image.png"
                              }
                              className="img-fluid"
                              alt={influencer?.handle_name || "Profile Picture"}
                            />

                            <h4>
                              {influencer?.influencer?.first_name ||
                              influencer?.influencer?.last_name
                                ? `${
                                    influencer?.influencer?.first_name || ""
                                  } ${
                                    influencer?.influencer?.middle_name || ""
                                  } ${
                                    influencer.influencer?.last_name || ""
                                  }`.trim()
                                : influencer.influencer?.handle_name || "N/A"}
                            </h4>
                          </div>
                          <div
                            className="InfluencerGenre"
                            style={{
                              marginLeft: "-21px",
                              paddingRight: "38px",
                            }}
                          >
                            {influencer?.influencer?.category &&
                            influencer?.influencer?.category?.length > 0 ? (
                              (() => {
                                const categoryList =
                                  influencer?.influencer?.category;

                                return (
                                  <Box
                                    display={"flex"}
                                    gap={1}
                                    alignItems={"center"}
                                  >
                                    {categoryList[0]?.name}
                                    {categoryList.length > 1 && (
                                      <Tooltip
                                        title={categoryList
                                          .slice(1)
                                          .map((cat) => cat.name)
                                          .filter(Boolean)
                                          .join(", ")}
                                        placement="bottom"
                                        sx={{
                                          "& .MuiTooltip-tooltip": {
                                            fontFamily:
                                              "Poppins, sans-serif !important",
                                            fontSize: "14px",
                                            letterSpacing: "0.5px",
                                          },
                                        }}
                                      >
                                        <Chip
                                          sx={{
                                            backgroundColor: "#ccc", // Light grey color
                                            color: "#333", // Dark text for contrast
                                            fontFamily: "Poppins, sans-serif",
                                            cursor: "pointer",
                                          }}
                                          label={`+ ${categoryList.length - 1}`}
                                        />
                                      </Tooltip>
                                    )}
                                  </Box>
                                );
                              })()
                            ) : (
                              <>N/A</>
                            )}
                          </div>

                          <div
                            className="InfluencerFollowes"
                            style={{
                              marginLeft: "-21px",
                              paddingRight: "38px",
                            }}
                          >
                            {influencer?.influencer?.instagram_stats?.followers
                              ? influencer?.influencer?.instagram_stats
                                  ?.followers
                              : "N/A"}
                          </div>
                          <div
                            className="InfluencerEngagement"
                            style={{ marginRight: "0" }}
                          >
                            {/* <p>
                              Reach: {influencer.reach ? influencer.reach : "-"}
                            </p> */}
                            <p>
                              Engagement:{" "}
                              {influencer?.influencer?.engagement !== null &&
                              influencer?.influencer?.engagement !== undefined
                                ? influencer?.influencer?.engagement
                                : "-"}
                            </p>

                            {/* <p>CPP: {influencer.cpp ? influencer.cpp : "-"}</p> */}
                          </div>
                          <div className="BtnGroups">
                            <button
                              className="AcceptBtn"
                              AcceptBtn
                              onClick={(e) => {
                                e.stopPropagation();
                                acceptRej(influencer, "Accepted");
                              }}
                            >
                              Accept
                            </button>
                            &nbsp;&nbsp;&nbsp;
                            <button
                              className="RejectBtn"
                              onClick={(e) => {
                                e.stopPropagation();
                                acceptRej(influencer, "Rejected");
                              }}
                            >
                              Reject
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    {" "}
                    <div className="min-h-screen flex items-center justify-center bg-gray-50">
                      <div className="text-center px-4 max-w-md mx-auto">
                        <div>
                          <img
                            src={NoCamp}
                            alt="No Campaigns"
                            className="object-contain"
                          />
                        </div>
                        <h2 className="Title">
                          No Collaboration Requests for <br />
                          this Campaign
                        </h2>
                        {/* <p className="text-gray-600 mb-8">
                        It looks like you haven't created any campaigns yet.
                        Ready to launch your first one?
                      </p> */}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
          {activeTab === "CollaborationSend" && (
            <div
              className="tab-pane fade show active"
              id="pills-check-requests"
              role="tabpanel"
              aria-labelledby="pills-check-requests-tab"
            >
              <div className="InfluancerCardView">
                {influencers?.requests?.length > 0 ? (
                  <>
                    <div className="influencer-card Menu">
                      <div
                        className="InfluencerProfile"
                        style={{ marginLeft: "-15px" }}
                      >
                        Creators
                      </div>
                      <div
                        className="InfluencerGenre"
                        style={{ marginLeft: "-68px", paddingLeft: "116px" }}
                      >
                        Genre
                      </div>
                      <div
                        className="InfluencerFollowes"
                        style={{ marginLeft: "-21px", paddingLeft: "84px" }}
                      >
                        Followers
                      </div>
                      <div
                        className="engagement"
                        style={{ marginLeft: "-56px", paddingLeft: "11px" }}
                      >
                        ER %
                      </div>
                      <div
                        className="InfluencerEngagement"
                        style={{ marginRight: "66px" }}
                      >
                        Actions
                      </div>
                    </div>
                    <div className="influencer-list">
                      {influencers?.requests
                        // ?.filter((ele) => ele.request_status === "Received")
                        ?.map((influencer) => (
                          <div
                            key={influencer.influencer_id}
                            className="influencer-card"
                          >
                            <div
                              className="InfluencerProfile"
                              style={{ marginLeft: "-22px" }}
                            >
                              <img
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                  borderRadius: "50px",
                                }}
                                src={
                                  influencer?.influencer?.profile ||
                                  "path/to/placeholder-image.png"
                                }
                                className="img-fluid"
                                alt={
                                  influencer?.handle_name || "Profile Picture"
                                }
                              />
                              <h4>
                                {influencer?.influencer?.first_name ||
                                influencer?.influencer?.last_name
                                  ? `${
                                      influencer?.influencer?.first_name || ""
                                    } ${
                                      influencer?.influencer?.middle_name || ""
                                    } ${
                                      influencer?.influencer?.last_name || ""
                                    }`
                                  : ""}
                              </h4>
                            </div>
                            <div
                              className="InfluencerGenre"
                              style={{
                                marginLeft: "-21px",
                                paddingRight: "38px",
                              }}
                            >
                              {influencer?.influencer?.category &&
                              influencer?.influencer?.category?.length > 0 ? (
                                (() => {
                                  const categoryList =
                                    influencer?.influencer?.category;

                                  return (
                                    <Box
                                      display={"flex"}
                                      gap={1}
                                      alignItems={"center"}
                                    >
                                      {categoryList[0]?.name}
                                      {categoryList.length > 1 && (
                                        <Tooltip
                                          title={categoryList
                                            .slice(1)
                                            .map((cat) => cat.name)
                                            .filter(Boolean)
                                            .join(", ")}
                                          placement="bottom"
                                          sx={{
                                            "& .MuiTooltip-tooltip": {
                                              fontFamily:
                                                "Poppins, sans-serif !important",
                                              fontSize: "14px",
                                              letterSpacing: "0.5px",
                                            },
                                          }}
                                        >
                                          <Chip
                                            sx={{
                                              backgroundColor: "#ccc", // Light grey color
                                              color: "#333", // Dark text for contrast
                                              fontFamily: "Poppins, sans-serif",
                                              cursor: "pointer",
                                            }}
                                            label={`+ ${
                                              categoryList.length - 1
                                            }`}
                                          />
                                        </Tooltip>
                                      )}
                                    </Box>
                                  );
                                })()
                              ) : (
                                <>N/A</>
                              )}
                            </div>

                            <div
                              className="InfluencerGenre"
                              style={{
                                marginLeft: "-21px",
                                paddingRight: "38px",
                              }}
                            >
                              {influencer?.influencer?.instagram_stats
                                ?.followers
                                ? influencer?.influencer?.instagram_stats
                                    ?.followers
                                : "N/A"}
                            </div>
                            <div
                              className="InfluencerEngagement"
                              style={{ marginRight: "0" }}
                            >
                              {/* <p>
                          Reach: {influencer.reach ? influencer.reach : "-"}
                        </p> */}
                              <p>
                                Engagement:{" "}
                                {influencer?.influencer?.engagement !== null &&
                                influencer?.influencer?.engagement !== undefined
                                  ? influencer?.influencer?.engagement
                                  : "-"}
                              </p>

                              {/* <p>CPP: {influencer.cpp ? influencer.cpp : "-"}</p> */}
                            </div>
                            <div className="BtnGroups">
                              <button
                                className="AcceptBtn"
                                onClick={() => revoke(influencer?.request_id)}
                              >
                                Revoke Request
                              </button>
                            </div>
                          </div>
                        ))}
                    </div>
                  </>
                ) : (
                  <div className="min-h-screen flex items-center justify-center bg-gray-50">
                    <div className="text-center px-4 max-w-md mx-auto">
                      <div>
                        <img
                          src={NoCamp}
                          alt="No Campaigns"
                          className="object-contain"
                        />
                      </div>
                      <h2 className="Title">
                        No Check Requests for <br /> this Campaign
                      </h2>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {/* Accepted Collaborations Tab */}
          {activeTab === "acceptedCollaborations" && (
            <div
              className="tab-pane fade show active"
              id="pills-campaign-collaborations"
              role="tabpanel"
              aria-labelledby="pills-campaign-collaborations-tab"
            >
              <div className="InfluancerCardView">
                {influencers?.requests?.length > 0 ? (
                  <>
                    <div className="influencer-card Menu">
                      <div
                        className="InfluencerProfile"
                        style={{ marginLeft: "-15px" }}
                      >
                        Creators
                      </div>
                      <div
                        className="InfluencerGenre"
                        style={{ marginLeft: "-68px", paddingLeft: "116px" }}
                      >
                        Genre
                      </div>

                      <div
                        className="InfluencerFollowes"
                        style={{ marginLeft: "91px" }}
                      >
                        Followers{" "}
                      </div>
                      <div
                        className="engagement"
                        style={{ marginLeft: "-25px" }}
                      >
                        ER %
                      </div>
                      <div
                        className="InfluencerEngagement"
                        style={{ marginRight: "66px", paddingLeft: "68px" }}
                      >
                        Actions
                      </div>
                    </div>
                    <div className="influencer-list">
                      {influencers?.requests.map((influencer) => (
                        <div
                          key={influencer.influencer_id}
                          className="influencer-card"
                        >
                          <div
                            className="InfluencerProfile"
                            style={{ marginLeft: "-22px" }}
                          >
                            <img
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "50px",
                              }}
                              src={
                                influencer?.influencer?.profile ||
                                "path/to/placeholder-image.png"
                              }
                              className="img-fluid"
                              alt={influencer?.handle_name || "Profile Picture"}
                            />
                            <h4>
                              {influencer?.influencer?.first_name ||
                              influencer?.influencer?.last_name
                                ? `${
                                    influencer?.influencer?.first_name || ""
                                  } ${
                                    influencer?.influencer?.middle_name || ""
                                  } ${influencer?.influencer?.last_name || ""}`
                                : ""}
                            </h4>
                          </div>
                          <div
                            className="InfluencerGenre"
                            style={{
                              marginLeft: "-21px",
                              paddingRight: "38px",
                            }}
                          >
                            {influencer?.influencer?.category &&
                            influencer?.influencer?.category?.length > 0 ? (
                              (() => {
                                const categoryList =
                                  influencer?.influencer?.category;

                                return (
                                  <Box
                                    display={"flex"}
                                    gap={1}
                                    alignItems={"center"}
                                  >
                                    {categoryList[0]?.name}
                                    {categoryList.length > 1 && (
                                      <Tooltip
                                        title={categoryList
                                          .slice(1)
                                          .map((cat) => cat.name)
                                          .filter(Boolean)
                                          .join(", ")}
                                        placement="bottom"
                                        sx={{
                                          "& .MuiTooltip-tooltip": {
                                            fontFamily:
                                              "Poppins, sans-serif !important",
                                            fontSize: "14px",
                                            letterSpacing: "0.5px",
                                          },
                                        }}
                                      >
                                        <Chip
                                          sx={{
                                            backgroundColor: "#ccc", // Light grey color
                                            color: "#333", // Dark text for contrast
                                            fontFamily: "Poppins, sans-serif",
                                            cursor: "pointer",
                                          }}
                                          label={`+ ${categoryList.length - 1}`}
                                        />
                                      </Tooltip>
                                    )}
                                  </Box>
                                );
                              })()
                            ) : (
                              <>N/A</>
                            )}
                          </div>

                          <div
                            className="InfluencerGenre"
                            style={{
                              marginLeft: "-21px",
                              paddingRight: "38px",
                            }}
                          >
                            {influencer?.influencer?.instagram_stats?.followers
                              ? influencer?.influencer?.instagram_stats
                                  ?.followers
                              : "N/A"}
                          </div>
                          <div
                            className="InfluencerEngagement"
                            style={{ marginRight: "0" }}
                          >
                            {/* <p>
                          Reach: {influencer.reach ? influencer.reach : "-"}
                        </p> */}
                            <p>
                              Engagement:{" "}
                              {influencer?.influencer?.engagement !== null &&
                              influencer?.influencer?.engagement !== undefined
                                ? influencer?.influencer?.engagement
                                : "-"}
                            </p>

                            {/* <p>CPP: {influencer.cpp ? influencer.cpp : "-"}</p> */}
                          </div>
                          <div className="BtnGroups">
                            <button
                              className="AcceptBtn"
                              onClick={() => SendContract(influencer)}
                            >
                              Upload Contract
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    {" "}
                    <div className="min-h-screen flex items-center justify-center bg-gray-50">
                      <div className="text-center px-4 max-w-md mx-auto">
                        <div>
                          <img
                            src={NoCamp}
                            alt="No Campaigns"
                            className="object-contain"
                          />
                        </div>
                        <h2 className="Title">
                          No Accepted Requests for <br />
                          this Campaign
                        </h2>
                        {/* <p className="text-gray-600 mb-8">
                      It looks like you haven't created any campaigns yet.
                      Ready to launch your first one?
                    </p> */}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
          {activeTab === "PendingContracts" && (
            <div
              className="tab-pane fade show active"
              id="pills-campaign-collaborations"
              role="tabpanel"
              aria-labelledby="pills-campaign-collaborations-tab"
            >
              <div className="InfluancerCardView">
                <div className="influencer-list">
                  {influencers?.requests?.length > 0 ? (
                    <>
                      <div className="influencer-card Menu">
                        <div
                          className="InfluencerProfile"
                          style={{ marginLeft: "20px" }}
                        >
                          Influencers
                        </div>
                        <div
                          className="InfluencerGenre"
                          style={{ marginLeft: "55px" }}
                        >
                          Genre
                        </div>

                        <div
                          className="InfluencerFollowes"
                          style={{ marginLeft: "90px" }}
                        >
                          Followers{" "}
                        </div>
                        <div
                          className="engagement"
                          // style={{ marginLeft: "56px", paddingLeft: "11px" }}
                        >
                          ER %
                        </div>
                        <div
                          className="InfluencerEngagement"
                          // style={{ marginRight: "66px" }}
                        >
                          Actions
                        </div>
                      </div>
                      {influencers?.requests?.map((influencer) => (
                        <div
                          key={influencer?.influencer?.influencer_id}
                          className="influencer-card"
                        >
                          <div
                            className="InfluencerProfile"
                            // style={{ marginLeft: "-22px" }}
                          >
                            <img
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "50px",
                              }}
                              src={
                                influencer?.influencer?.profile ||
                                "path/to/placeholder-image.png"
                              }
                              className="img-fluid"
                              alt={influencer?.handle_name || "Profile Picture"}
                            />
                            <h4>
                              {influencer?.influencer?.first_name ||
                              influencer?.influencer?.last_name
                                ? `${
                                    influencer?.influencer?.first_name || ""
                                  } ${
                                    influencer?.influencer?.middle_name || ""
                                  } ${influencer?.influencer?.last_name || ""}`
                                : ""}
                            </h4>
                          </div>
                          <div
                            className="InfluencerGenre"
                            // style={{
                            //   marginLeft: "-21px",
                            //   paddingRight: "38px",
                            // }}
                          >
                            {influencer?.influencer?.category &&
                            influencer?.influencer?.category?.length > 0 ? (
                              (() => {
                                const categoryList =
                                  influencer?.influencer?.category;

                                return (
                                  <Box
                                    display={"flex"}
                                    gap={1}
                                    alignItems={"center"}
                                  >
                                    {categoryList[0]?.name}
                                    {categoryList.length > 1 && (
                                      <Tooltip
                                        title={categoryList
                                          .slice(1)
                                          .map((cat) => cat.name)
                                          .filter(Boolean)
                                          .join(", ")}
                                        placement="bottom"
                                        sx={{
                                          "& .MuiTooltip-tooltip": {
                                            fontFamily:
                                              "Poppins, sans-serif !important",
                                            fontSize: "14px",
                                            letterSpacing: "0.5px",
                                          },
                                        }}
                                      >
                                        <Chip
                                          sx={{
                                            backgroundColor: "#ccc", // Light grey color
                                            color: "#333", // Dark text for contrast
                                            fontFamily: "Poppins, sans-serif",
                                            cursor: "pointer",
                                          }}
                                          label={`+ ${categoryList.length - 1}`}
                                        />
                                      </Tooltip>
                                    )}
                                  </Box>
                                );
                              })()
                            ) : (
                              <>N/A</>
                            )}
                          </div>

                          <div
                            className="InfluencerGenre"
                            // style={{
                            //   marginLeft: "-21px",
                            //   paddingRight: "38px",
                            // }}
                          >
                            {influencer?.influencer?.instagram_stats?.followers
                              ? influencer?.influencer?.instagram_stats
                                  ?.followers
                              : "N/A"}
                          </div>
                          <div
                            className="InfluencerEngagement"
                            // style={{ marginRight: "0" }}
                          >
                            {/* <p>
                            Reach: {influencer.reach ? influencer.reach : "-"}
                          </p> */}
                            <p>
                              Engagement:{" "}
                              {influencer?.influencer?.engagement !== null &&
                              influencer?.influencer?.engagement !== undefined
                                ? influencer?.influencer?.engagement
                                : "-"}
                            </p>

                            {/* <p>CPP: {influencer.cpp ? influencer.cpp : "-"}</p> */}
                          </div>
                          <div className="BtnGroups">
                            <button
                              className="RejectBtn"
                              onClick={() =>
                                UnsendContract(influencer?.request_id)
                              }
                            >
                              Unsend Contract
                            </button>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      {" "}
                      <div className="min-h-screen flex items-center justify-center bg-gray-50">
                        <div className="text-center px-4 max-w-md mx-auto">
                          <div>
                            <img
                              src={NoCamp}
                              alt="No Campaigns"
                              className="object-contain"
                            />
                          </div>
                          <h2 className="Title">No Pending Contracts</h2>
                          <p className="text-gray-600 mb-8">
                            It looks like you haven't created any campaigns yet.
                            Ready to launch your first one?
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          {activeTab === "AcceptedContracts" && (
            <div
              className="tab-pane fade show active"
              id="pills-campaign-collaborations"
              role="tabpanel"
              aria-labelledby="pills-campaign-collaborations-tab"
            >
              <div className="InfluancerCardView">
                <div className="influencer-list">
                  {influencers?.requests?.length > 0 ? (
                    <>
                      <div className="influencer-card Menu">
                        <div
                          className="InfluencerProfile"
                          style={{ marginLeft: "-15px" }}
                        >
                          Influencers
                        </div>
                        <div
                          className="InfluencerGenre"
                          style={{ marginLeft: "-68px", paddingLeft: "116px" }}
                        >
                          Genre
                        </div>

                        <div
                          className="InfluencerFollowes"
                          style={{ marginLeft: "-91px", paddingLeft: "84px" }}
                        >
                          Followers{" "}
                        </div>
                        <div
                          className="engagement"
                          style={{ marginLeft: "56px", paddingLeft: "11px" }}
                        >
                          ER %
                        </div>
                        <div
                          className="InfluencerEngagement"
                          style={{ marginRight: "66px" }}
                        >
                          Actions
                        </div>
                      </div>
                      {influencers?.requests
                        ?.filter((ele) => ele.request_status === "Accepted")
                        .map((influencer) => (
                          <div
                            key={influencer.influencer_id}
                            className="influencer-card"
                          >
                            <div
                              className="InfluencerProfile"
                              style={{ marginLeft: "-22px" }}
                            >
                              <img
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                  borderRadius: "50px",
                                }}
                                src={
                                  influencer?.influencer?.profile ||
                                  "path/to/placeholder-image.png"
                                }
                                className="img-fluid"
                                alt={
                                  influencer?.handle_name || "Profile Picture"
                                }
                              />
                              <h4>
                                {influencer?.influencer?.first_name ||
                                influencer?.influencer?.last_name
                                  ? `${
                                      influencer?.influencer?.first_name || ""
                                    } ${
                                      influencer?.influencer?.middle_name || ""
                                    } ${
                                      influencer?.influencer?.last_name || ""
                                    }`
                                  : ""}
                              </h4>
                            </div>
                            <div
                              className="InfluencerGenre"
                              style={{
                                marginLeft: "-21px",
                                paddingRight: "38px",
                              }}
                            >
                              {influencer?.influencer?.category &&
                              influencer?.influencer?.category?.length > 0 ? (
                                (() => {
                                  const categoryList =
                                    influencer?.influencer?.category;

                                  return (
                                    <Box
                                      display={"flex"}
                                      gap={1}
                                      alignItems={"center"}
                                    >
                                      {categoryList[0]?.name}
                                      {categoryList.length > 1 && (
                                        <Tooltip
                                          title={categoryList
                                            .slice(1)
                                            .map((cat) => cat.name)
                                            .filter(Boolean)
                                            .join(", ")}
                                          placement="bottom"
                                          sx={{
                                            "& .MuiTooltip-tooltip": {
                                              fontFamily:
                                                "Poppins, sans-serif !important",
                                              fontSize: "14px",
                                              letterSpacing: "0.5px",
                                            },
                                          }}
                                        >
                                          <Chip
                                            sx={{
                                              backgroundColor: "#ccc", // Light grey color
                                              color: "#333", // Dark text for contrast
                                              fontFamily: "Poppins, sans-serif",
                                              cursor: "pointer",
                                            }}
                                            label={`+ ${
                                              categoryList.length - 1
                                            }`}
                                          />
                                        </Tooltip>
                                      )}
                                    </Box>
                                  );
                                })()
                              ) : (
                                <>N/A</>
                              )}
                            </div>

                            <div
                              className="InfluencerGenre"
                              style={{
                                marginLeft: "-21px",
                                paddingRight: "38px",
                              }}
                            >
                              {influencer?.influencer?.instagram_stats
                                ?.followers
                                ? influencer?.influencer?.instagram_stats
                                    ?.followers
                                : "N/A"}
                            </div>
                            <div
                              className="InfluencerEngagement"
                              style={{ marginRight: "0" }}
                            >
                              {/* <p>
                          Reach: {influencer.reach ? influencer.reach : "-"}
                        </p> */}
                              <p>
                                Engagement:{" "}
                                {influencer?.influencer?.engagement !== null &&
                                influencer?.influencer?.engagement !== undefined
                                  ? influencer?.influencer?.engagement
                                  : "-"}
                              </p>

                              {/* <p>CPP: {influencer.cpp ? influencer.cpp : "-"}</p> */}
                            </div>
                            <div className="BtnGroups">
                              <button
                                className="RejectBtn"
                                onClick={() =>
                                  openPriviewModal(influencer?.contract_link)
                                }
                              >
                                View Signed Contract
                              </button>
                            </div>
                          </div>
                        ))}
                    </>
                  ) : (
                    <>
                      {" "}
                      <div className="min-h-screen flex items-center justify-center bg-gray-50">
                        <div className="text-center px-4 max-w-md mx-auto">
                          <div>
                            <img
                              src={NoCamp}
                              alt="No Campaigns"
                              className="object-contain"
                            />
                          </div>
                          <h2 className="Title">No Accepted Contracts</h2>
                          <p className="text-gray-600 mb-8">
                            It looks like you haven't created any campaigns yet.
                            Ready to launch your first one?
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Body
          className="custom-modal"
          style={{
            color: "rgb(82 82 82)",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          Are you sure you want to delete this campaign?
        </Modal.Body>
        <Modal.Footer
          className="d-flex justify-content-center custom-modal"
          style={{ borderTop: "none" }}
        >
          <BootstrapButton
            variant="secondary"
            onClick={() => setShowModal(false)}
          >
            No
          </BootstrapButton>
          <BootstrapButton
            onClick={handleDeleteCampaign}
            className="publish-btn"
            style={{ backgroundColor: "#668770" }}
          >
            Yes
          </BootstrapButton>
        </Modal.Footer>
      </Modal>

      {priviewContract && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1000,
          }}
          onClick={closePriviewModal}
        >
          <div
            className="modal-content"
            style={{
              background: "#fff",
              padding: "20px",
              margin: "50px auto",
              width: "80%",
              maxWidth: "800px",
              borderRadius: "8px",
              position: "relative",
              height: "90vh",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5>Preview Contract</h5>
              <button
                onClick={closePriviewModal}
                className="btn btn-sm btn-outline-secondary"
              >
                ✕
              </button>
            </div>
            {console.log(CampaignFormCreate, "CampaignFormCreate")}
            <iframe
              src={`https://docs.google.com/gview?url=${encodeURIComponent(
                contractLink
              )}&embedded=true`}
              width="100%"
              height="600px"
              frameBorder="0"
            />

            <div className="d-flex justify-content-between mt-3">
              <div></div>

              <a
                href={contractLink}
                download="Contract.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="GreenDarkBtn"
              >
                Download Contract
              </a>
            </div>
          </div>
        </div>
      )}

      {showContractModal && (
        <div
          className="upload-modal-overlay"
          onClick={() => setShowContractModal(false)}
        >
          <div
            className="upload-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="text-center">
                <h5>Upload Contract</h5>
              </div>
              <button
                onClick={() => setShowContractModal(false)}
                className="btn btn-sm btn-outline-secondary"
              >
                ✕
              </button>
            </div>

            {/* Render the component with props */}
            <ContractforCollaboration requestId={selectedRequestId} />
          </div>
        </div>
      )}
    </>
  );
}

export default CampaignDetails;
